var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgIconPerson = function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 5.5,
    r: 4,
    fill: "#FFD766"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFD766",
    d: "M2 19a8 8 0 1 1 16 0v1H2z"
  })));
};
export default SvgIconPerson;